gsap.registerPlugin(ScrollTrigger);

let lenis = null;
if (window.innerWidth >= 990 && !document.body.classList.contains('template-product')) {
  lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  });
  lenis.on('scroll', ScrollTrigger.update);
  gsap.ticker.add((time) => { lenis.raf(time * 1000); });
  gsap.ticker.lagSmoothing(0);

  // ページの高さが変わったら（関連商品のAJAX挿入・画像読み込み等）Lenisを再計測
  new ResizeObserver(() => { lenis.resize(); }).observe(document.body);
}

(function () {
  var isHomepage = document.body.classList.contains('template-index');
  var hero = document.querySelector('.falmo-hero__video')
          || document.querySelector('#MainContent > .shopify-section')
          || document.querySelector('.banner');
  var lastScrollY = window.scrollY;

  if (!isHomepage) return;

  var hdr = document.querySelector('sticky-header') || document.querySelector('.section-header');

  function updateHeaderHome() {
    if (!hero || !hdr) return;
    var h = hero.offsetHeight;
    var y = window.scrollY;

    // 色：ヒーローの45%〜70%でゆっくり切り替え
    if (y >= h * 0.55) {
      document.body.classList.add('falmo-header-opaque');
    } else {
      document.body.classList.remove('falmo-header-opaque');
    }

    // 消え：ヒーローの75%〜100%でスクロール量に比例してフェード
    var s = h * 0.75, e = h;
    var p = (y - s) / (e - s);
    p = p < 0 ? 0 : (p > 1 ? 1 : p);
    hdr.style.opacity = String(1 - p);
    hdr.style.transform = 'translateY(' + (-24 * p) + 'px)';
    hdr.style.pointerEvents = p > 0.9 ? 'none' : '';
  }

  window.addEventListener('scroll', updateHeaderHome, { passive: true });
  updateHeaderHome();
})();
// ===== FALMO モーション定数（今後の演出は全部ここから引く） =====
window.FALMO_MOTION = {
  ease: 'power2.out',  // 全サイト共通イージング
  durS: 0.8,           // 短い動き（ホバー応答など）
  durL: 1.2,           // 大きい動き(リビール・フェード)
  rise: 20             // フェード時の縦移動量(px)
};

// ===== 商品ページ: リビール演出（ネイティブスクロール対応） =====
(function(){
  if (!document.body.classList.contains('template-product')) return;
  var M = window.FALMO_MOTION;

  document.addEventListener('DOMContentLoaded', function(){
    // テーマ標準のスクロールアニメと二重にならないように外す
    document.querySelectorAll('.scroll-trigger').forEach(function(el){
      el.classList.remove('scroll-trigger','animate--fade-in','animate--slide-in');
    });

    // 商品情報カラム: ページ表示時にふわっと
    var info = document.querySelector('.product__info-wrapper');
    if (info) gsap.fromTo(info,
      {opacity:0, y:M.rise},
      {opacity:1, y:0, duration:M.durL, ease:M.ease, delay:0.1});

    // 画像: 視界に入ったら1回だけふわっと
    var items = document.querySelectorAll('[id^="MainProduct"] .product__media-item');
    if (!items.length) return;
    gsap.set(items, {opacity:0, y:M.rise});
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting){
          gsap.to(en.target, {opacity:1, y:0, duration:M.durL, ease:M.ease});
          io.unobserve(en.target);
        }
      });
    }, {threshold:0.12});
    items.forEach(function(el){ io.observe(el); });
  });
})();
// ===== 商品ページ: 文章カラムのスクロールヒント（初回スクロールで消滅） =====
(function(){
  if (!document.body.classList.contains('template-product')) return;
  if (window.innerWidth < 990) return;
  var M = window.FALMO_MOTION;
  window.addEventListener('load', function(){
    var info = document.querySelector('.product__info-wrapper');
    if (!info) return;
    // すでに最下部まで読まれている場合も含め、続きが無ければ出さない
    if (info.scrollHeight - info.scrollTop - info.clientHeight < 40) return;
    var hint = document.createElement('div');
    hint.className = 'falmo-scroll-hint';
    hint.innerHTML = '<svg viewBox="0 0 16 16" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6l5 5 5-5"/></svg>';
    info.appendChild(hint);
    gsap.fromTo(hint, {opacity:0}, {opacity:1, duration:M.durL, ease:M.ease, delay:0.8});
    var base = info.scrollTop, done = false;
    info.addEventListener('scroll', function(){
      if (done) return;
      if (Math.abs(info.scrollTop - base) < 30) return; // 復元スクロール等のノイズは無視
      done = true;
      gsap.to(hint, {opacity:0, duration:M.durS, ease:M.ease, onComplete:function(){ hint.remove(); }});
    }, {passive:true});
  });
})();
// ===== 商品ページ: 関連商品の読み込みパン対策（高さ確保＋フェードイン） =====
(function(){
  if (!document.body.classList.contains('template-product')) return;
  var M = window.FALMO_MOTION;
  document.addEventListener('DOMContentLoaded', function(){
    var rec = document.querySelector('product-recommendations');
    if (!rec) return;

    // ① 中身が来る前に高さを確保（レイアウトシフト＝ガタつき防止）
    //    商品カードの縦横比ぶん、画面幅から概算で min-height を先に与える
    if (window.innerWidth >= 990) {
      rec.style.minHeight = '520px';   // 4列・カード高さの概算。後で実値に合わせて調整可
    } else {
      rec.style.minHeight = '420px';
    }
    rec.style.display = 'block';

    // ② 中身が挿入された瞬間を捉えてフェードイン
    var done = false;
    function reveal(){
      if (done) return;
      var inner = rec.querySelector('.grid, ul, .related-products');
      var cards = rec.querySelectorAll('.grid__item');
      if (!cards.length) return false;
      done = true;
      // 出現はふわっと。高さ確保済みなのでガタつかない
      gsap.fromTo(cards,
        {opacity:0, y:M.rise},
        {opacity:1, y:0, duration:M.durL, ease:M.ease, stagger:0.1,
         onComplete:function(){ rec.style.minHeight = ''; }  // 演出後は高さ固定を解除
        });
      return true;
    }
    // 既に在ればすぐ、まだなら挿入を監視
    if (!reveal()) {
      var mo = new MutationObserver(function(){ if (reveal()) mo.disconnect(); });
      mo.observe(rec, {childList:true, subtree:true});
    }
  });
})();